module.exports = __webpack_public_path__ + "img/lg_ring_g_s_0_null@3x.9af90a37.png";